var fku = fku || {};
( function () {
    'use strict';
    jQuery( function () {
        fku.init();
    } );

    fku.init = function () {
        fku.customSearchBar.init();
        fku.ecom.range.init();
    };
    fku.customSearchBar = {};
    fku.customSearchBar.init = function () {
        jQuery( '.js-custom-search-form' ).on( 'submit', function ( e ) {
            e.preventDefault();
            var customSearchBarValue = jQuery( this ).find( '.custom-search-input' ).val();
            e4.util.hash.set( 'search', customSearchBarValue );
        } );
        jQuery( '.js-trigger-search' ).on( 'click', function ( e ) {
            e.preventDefault();
            jQuery( '.js-custom-search-form' ).trigger( 'submit' );
        } );
    };
    fku.ecom = {
        range: {
            timeout: null,
            base: {},
            init: function () {
                jQuery.getScript( '//code.jquery.com/ui/1.12.1/jquery-ui.js', function () {
                    fku.ecom.range.bindEvents();
                } );
            },
            bindEvents: function () {
                jQuery( '#js-e-productlist-filters' ).on( 'filters:updated', function () {
                    jQuery( '.js-e-productlist-filters-option-rangeslider' ).each( function () {
                        var jThis    = jQuery( this ),
                            param    = jThis.data( 'param' ),
                            minRange = jThis.data( 'min-range' ),
                            maxRange = jThis.data( 'max-range' );
                        fku.ecom.range.base[ param ] = fku.ecom.range.base[ param ] || [ minRange, maxRange ];
                        jThis.find( '.js-e-productlist-filters-option-rangeslider-range' ).slider( {
                            range: true,
                            min: fku.ecom.range.base[ param ][ 0 ],
                            max: fku.ecom.range.base[ param ][ 1 ],
                            step: 0.1,
                            values: [ jThis.find( '.js-e-productlist-filters-option-rangeslider-range-min' ).val(), jThis.find( '.js-e-productlist-filters-option-rangeslider-range-max' ).val() ],
                            slide: function ( event, ui ) {
                                jThis.find( '.js-e-productlist-filters-option-rangeslider-values' ).find( '.js-e-productlist-filters-option-rangeslider-values-min' ).text( ui.values[ 0 ] );
                                jThis.find( '.js-e-productlist-filters-option-rangeslider-values' ).find( '.js-e-productlist-filters-option-rangeslider-values-max' ).text( ui.values[ 1 ] );
                            },
                            change: function ( event, ui ) {
                                clearTimeout( fku.ecom.range.timeout );
                                jThis.find( '.js-e-productlist-filters-option-rangeslider-range-min' ).val( ui.values[ 0 ] );
                                jThis.find( '.js-e-productlist-filters-option-rangeslider-range-max' ).val( ui.values[ 1 ] );
                                fku.ecom.range.timeout = setTimeout( function () {
                                    e4.productlist.data.post( e4.productlist.jProductList.find( '.js-e-productlist-form' ).serialize(), e4.productlist.jProductList.offset().top );
                                }, 1000 );
                            }
                        } );
                        var minValue = jThis.find( '.js-e-productlist-filters-option-rangeslider-range' ).slider( 'values', 0 ),
                            maxValue = jThis.find( '.js-e-productlist-filters-option-rangeslider-range' ).slider( 'values', 1 );
                        jThis.find( '.js-e-productlist-filters-option-rangeslider-range-min' ).val( minValue );
                        jThis.find( '.js-e-productlist-filters-option-rangeslider-range-max' ).val( maxValue );
                        jThis.find( '.js-e-productlist-filters-option-rangeslider-values' ).find( '.js-e-productlist-filters-option-rangeslider-values-min' ).text( minValue );
                        jThis.find( '.js-e-productlist-filters-option-rangeslider-values' ).find( '.js-e-productlist-filters-option-rangeslider-values-max' ).text( maxValue );
                    } );
                } );
            }
        }
    };
    fku.util = {
        formatStringToJavascriptNumber: function ( strNumber ) {
            return parseFloat( String( strNumber ).replace( new RegExp( '\\' + e4.settings.separatorInteger, 'g' ), '' ).replace( new RegExp( '\\' + e4.settings.separatorDecimal, 'g' ), '.' ) );
        },
        formatJavascriptNumberToString: function ( intNumber ) {
            var strNumber = String( parseFloat( Math.round( intNumber * 100 ) / 100 ).toFixed( 2 ) ).replace( /[^\d\.\-]/g, '' ).replace( /(\.\d{2})[\W\w]+/g, '$1' ).split( '' ).reverse().join( '' ).replace( /(\d{3})/g, '$1.' ).split( '' ).reverse().join( '' ).replace( /^([\-]{0,1})\./, '$1' ).replace( /\.(\d\d)$/, ',' + '$1' ).replace( /\.(\d)$/, ',' + '$1' + '0' ).replace( /\.$/, ',00' );
            if ( e4.settings.lang !== 'da' ) {
                strNumber = strNumber.replace( /\./g, '{integer}' );
                strNumber = strNumber.replace( /\,/g, '{decimal}' );
                strNumber = strNumber.replace( /{integer}/g, e4.settings.separatorInteger );
                strNumber = strNumber.replace( /{decimal}/g, e4.settings.separatorDecimal );
            }
            return strNumber;
        }
    };
}() );

jQuery( '.js-fku-ecom-variant-modal' ).on( 'shown.bs.modal', function ( event ) {
    console.log( jQuery( event.target ) );
    var jModal           = jQuery( event.target ),
        strVariantName   = jModal.find( '.js-fku-ecom-product-variant-name' ).text(),
        strVariantNumber = jModal.find( '.js-fku-ecom-product-variant-number' ).text();
    console.log( strVariantName, strVariantNumber );
    jModal.find( '.js-fku-ecom-form-input-product-variant-name' ).val( strVariantName );
    jModal.find( '.js-fku-ecom-form-input-product-variant-number' ).val( strVariantNumber );
    console.log( jModal.find( '.js-ecom-variant-product-name' ), jModal.find( '.js-ecom-variant-product-number' ) );
} );

jQuery( function () {

    if ( jQuery( '.js-login-failed-modal' ).length > 0 ) {
        jQuery( '.js-login-failed-modal' ).click();
    }

    jQuery( '[data-toggle="tooltip"]' ).tooltip();
} );

jQuery('a[href="https://system24.microbizz.dk/x/index.php/3175"]').attr('target', '_blank');
